import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Text, Stack, Separator, Badge } from '@guestyci/arc';

import GoogleIcon from './icons/GoogleIcon';
const SocialLogin = ({ onGoogleSignIn, disabled, showGoogle = true }) => {
  if (!showGoogle) {
    return null;
  }

  return (
    <Stack spacing={7} direction="column">
      <Stack direction="row" align="center" spacing={2}>
        <div className="gst-flex-1">
          <Separator orientation="horizontal" />
        </div>
        <Badge variant="secondary">{t('OR')}</Badge>
        <div className="gst-flex-1">
          <Separator orientation="horizontal" />
        </div>
      </Stack>

      <Button
        type="button"
        variant="secondary"
        className="gst-w-full"
        onClick={onGoogleSignIn}
        disabled={disabled}
      >
        <Stack direction="row" spacing={2} align="center" justify="center">
          <GoogleIcon size={16} />
          <Text size="sm" bold>{t('Sign in with Google')}</Text>
        </Stack>
      </Button>
    </Stack>
  );
};

export default SocialLogin;
